window.lightbox = require('lightbox2/dist/js/lightbox.min.js');

(function ($) {
    "use strict";

    /*----------------------------------------
	   Sticky Menu Activation
	---------------------------------*/
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 350) {
            $('.header-sticky').addClass('sticky');
        } else {
            $('.header-sticky').removeClass('sticky');
        }
    });

    /**
     * Navbar Menu scroll to anchor
     */

    $('.header .header-bottom .main-menu li:not(.has-children) a[href*="#"]').each(function () {
        let href = $(this).attr('href');
        let id = href.split("#").pop();

        if(id !== href) {
            $(this).click(function (event) {
                event.preventDefault();
                $('#' + id)[0].scrollIntoView({behavior: "smooth"});
            })
        }
    });

    $('.header .mobile-menu-wrapper .mobile-menu li:not(.has-children) a[href*="#"]').each(function () {
        let href = $(this).attr('href');
        let id = href.split("#").pop();

        if(id !== href) {
            $(this).click(function (event) {
                event.preventDefault();
                $('.mobile-menu-wrapper').removeClass('open');
                $('#' + id)[0].scrollIntoView({behavior: "smooth"});
            })
        }
    });


    /*----------------------------------------
        Off Canvas Mobile Menu
    -------------------------------------------*/
    $(".mobile-menu-bar").on('click', function () {
        $("body").addClass('fix');
        $(".mobile-menu-wrapper").addClass('open');
    });

    $(".btn-close-bar,.body-overlay").on('click', function () {
        $("body").removeClass('fix');
        $(".mobile-menu-wrapper").removeClass('open');
    });
    /*----------------------------------------
		Responsive Mobile Menu
	------------------------------------------*/
    //Variables
    var $offCanvasNav = $('.mobile-menu'),
        $offCanvasNavSubMenu = $offCanvasNav.find('.dropdown');

    //Close Off Canvas Sub Menu
    $offCanvasNavSubMenu.slideUp();

    //Category Sub Menu Toggle
    $offCanvasNav.on('click', 'li a, li .menu-expand', function(e) {
        var $this = $(this);
        if ( $this.parent().attr('class') !== undefined && ($this.parent().attr('class').match(/\b(menu-item-has-children|has-children|has-sub-menu)\b/)) && ($this.attr('href') === '#' || $this.hasClass('menu-expand')) ) {
            e.preventDefault();
            if ($this.siblings('ul:visible').length){
                $this.parent('li').removeClass('active');
                $this.siblings('ul').slideUp();
            } else {
                $this.parent('li').addClass('active');
                $this.closest('li').siblings('li').removeClass('active').find('li').removeClass('active');
                $this.closest('li').siblings('li').find('ul:visible').slideUp();
                $this.siblings('ul').slideDown();
            }
        }
    });

    /*----------------------------------------
        Aos Activation Js
    ------------------------------------------*/
    $(window).on('scroll', function(){
        AOS.init({
            duration: 1200, // values from 0 to 3000, with step 50ms
            disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
            offset: 30, // offset (in px) from the original trigger point
            once: true,
            easing: 'ease',
        });
    });

    AOS.init({
        duration: 1200, // values from 0 to 3000, with step 50ms
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        offset: 30, // offset (in px) from the original trigger point
        once: true,
        easing: 'ease',
    });

})(jQuery);